module.exports = __webpack_public_path__ + "static/img/irole.410ef01.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/wxsjglm/irole.png
// module id = neIx
// module chunks = 7